// extracted by mini-css-extract-plugin
export default {"TextWithIcon":"TextWithIcon_TextWithIcon__DgUql","icon":"TextWithIcon_icon__N9TKN","text":"TextWithIcon_text__u84kL"};